import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SessionService } from '../../core/session.service';
import { I18nService } from '../../core/i18n.service';
import { UserProfile } from '../../core/models';
import { safeSameOriginOrHttpImageUrl } from '../../core/url-security';

@Component({ selector: 'app-profile-menu', standalone: true, imports: [RouterLink], templateUrl: './profile-menu.html', styleUrl: './profile-menu.scss' })
export class ProfileMenu {
  avatarLoadFailed = false;
  constructor(public session: SessionService, public i18n: I18nService) {}
  get user(): UserProfile | null { return this.session.currentUser(); }
  private readonly pendingPictureDeletionStorageKey = 'phdcompass.pendingProfilePictureDeletionUrl';

  get displayedAvatar(): string {
    const avatar = this.user?.avatar ?? '';
    if (this.avatarLoadFailed || (avatar && avatar === this.pendingDeletedAvatarUrl)) return '';
    return safeSameOriginOrHttpImageUrl(avatar);
  }
  handleAvatarLoadError(): void { this.avatarLoadFailed = true; }

  get initials(): string {
    const user = this.user;
    const firstInitial = user?.firstName?.trim().charAt(0) || '?';
    const lastInitial = user?.lastName?.trim().charAt(0) || '?';
    return `${firstInitial}${lastInitial}`.toUpperCase();
  }

  get profileButtonLabel(): string {
    const user = this.user;
    const lastInitial = user?.lastName?.trim().charAt(0).toUpperCase() || '?';
    return `${lastInitial} ${user?.firstName?.trim() || this.i18n.t('common.profile')}`;
  }

  private get pendingDeletedAvatarUrl(): string {
    try { return sessionStorage.getItem(this.pendingPictureDeletionStorageKey) ?? ''; } catch { return ''; }
  }
}
